import { ComponentProps } from 'react'
import { cn } from '~utils/cn'

const IssueTag = ({
  children,
  className,
}: Pick<ComponentProps<'div'>, 'children' | 'className'>) => {
  return (
    <div
      className={cn(
        'w-fit whitespace-nowrap rounded-lg bg-gray-200 px-2 py-1 dark:bg-gray-800 dark:text-gray-500 text-gray-700 text-label-2',
        className
      )}
    >
      {children}
    </div>
  )
}

export default IssueTag
